import _ from 'lodash'
import { MutationTree } from 'vuex';
import { SpirApplication, SpirApplicationsState } from '@/store/applications/spir/types';

const mutations: MutationTree<SpirApplicationsState> = {
  gotSpirApplication: (
    state,
    spir: SpirApplication,
  ) => {
    state.applications = _.uniqBy([
      spir,
      ...state.applications,
    ], 'applicationId')
  },
};

export default mutations
